<template>
    <article class="product-listing">
		<product-content v-for="product in productsParsed"
                :key="product.id" 
                :product="product" >
            <!-- <slot v-bind:product="product"></slot> -->
		</product-content> 
	</article> 
</template>

<script>
import { pagesComputed } from '@/features/pages/store'
import ProductContent from './ProductCardDisplay'
export default {
    components: {
        ProductContent
    },
    computed: {
        ...pagesComputed,
        productsParsed() {            
            return [
                ...this.pages.filter(page => {
                    const settings = page.settings
                    try { return settings.productList }
                    catch(e) { return false }
                })
            ].sort((a, b) => a.position > b.position) 
        }
    }
}
</script>